// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import contact from "../../../assets/images/details/contact.svg";

// fake assets
import avatar from "../../../assets/images/details/avatar.svg";

const Contact = ({ data }) => {
  return (
    <div className={styles.contact}>
      <div className={styles.wrap}>
        <div className={styles.info_wrap}>
          <img src={avatar} alt="contact_host" />
          <div>
            <h6>Contact Host</h6>
            <p>+{data?.PhoneNo}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
